import React, { useEffect, useState, useMemo } from 'react';
import Select from 'react-select';
import { FormGroup } from 'react-bootstrap';
import moment from 'moment';
import { isEmpty, uniqBy, cloneDeep } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import * as devBomAction from '../Bom/store/BOMConfig.action';
import * as bomAction from '../../Library/BomLibrary/store/BomLibrary.action';
import * as action from './store/product.action';
import {
  SelectBoxStylesForProductAttribute,
  customStylesForProdAttribute,
  customStyles,
  hoverMultipleTooltip,
  checkArray,
  Page_Size,
  shortenandHoverString,
  currencyCodes,
  convertSelectLabel,
} from '../../../Components/helper';
import * as supplierAction from '../../Supplier/store/Supplier.action';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

function TopProductAttributeTable({ showData, fromBomLib, setTopColour, setTopSupplier, setTopCompSupplier, setTopColourWayrefData, devOrderId, setstate }) {
  const dispatch = useDispatch();
  const paramId = useParams();
  const { t } = useTranslation('common');
  const ProductTestingData = useSelector((redState) => redState);
  const { Measuremets, SystemMastersDetails, SuppliersDetails, BomLibraryDetails, ProductAttributeDetails, BOMConfigDetails } = ProductTestingData;
  const { ProductColourList } = Measuremets;
  const { unitList } = SystemMastersDetails;
  const { productDetails } = BOMConfigDetails;
  const { tier2AndAboveList, tier1List, productSupplier } = SuppliersDetails;
  const { ReferenceType, Composition } = BomLibraryDetails;
  const activeReferenceType = useMemo(() => ReferenceType?.filter((option) => option?.isActive) ?? [], [ReferenceType]);
  const { factories } = ProductAttributeDetails;
  const [savedEdit, setSaveEdit] = useState(false);
  const [sizeValue, setSizeValue] = useState('');
  const [addInfoValue, setAddInfoValue] = useState('');
  const [componentDescValue, setComponentDescValue] = useState('');
  const [weightValue, setWeightValue] = useState('');
  const [quntityValue, setQuntityValue] = useState('');
  const [pricePerUnitValue, setPricePerUnitValue] = useState('');
  const [pricePerUnitCurrency, setPricePerUnitCurrency] = useState(null);
  const [unitOptions, setUnitOptions] = useState([]);
  const [SupplierOptions, setSupplierOptions] = useState([]);
  const [BomSuppliers, selectBomSuppliers] = useState([]);
  const [weightUOM, setWeightUOM] = useState(null);
  const [quntityUOM, setQuntityUOM] = useState(null);
  const [sizeUOM, setSizeUOM] = useState(null);
  const [selectedColourWay, setSelectedColourWay] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [selectedCompSupplier, setSelectedCompSupplier] = useState(null);
  const [bomSubType, setBomSubType] = useState(null);
  const [selectedColourWayRef, setSelectedColourWayRef] = useState(null);
  const [selectedColourWayName, setSelectedColourWayName] = useState(null);
  const [state, setState] = useState({ componentSupplierOptiosn: [] });
  const { componentSupplierOptiosn } = state;
  const [customBom, setCustomBom] = useState({
    composition: [
      {
        percentage: null,
        composition: null,
      },
    ],
  });

  // Currency options memoized
  const currencyOptions = useMemo(() => {
    return currencyCodes?.map((currKey) => convertSelectLabel(currKey, true));
  }, [currencyCodes?.length]);

  useEffect(() => {
    const callFn = async () => {
      await dispatch(
        supplierAction.fetchProductSupplierListAction({
          devOrderId,
        }),
      );
    };
    if (devOrderId) callFn();
  }, [dispatch, devOrderId]);

  useEffect(() => {
    if (!isEmpty(unitList)) {
      setUnitOptions([...unitList]);
    }
  }, [unitList, showData]);

  const forSupplier = () => {
    const updateData = cloneDeep(showData);
    if (!isEmpty(updateData?.suppliers) && isEmpty(updateData?.suppliers[0]?.name)) {
      updateData.suppliers = [];
    }
    return updateData.suppliers;
  };

  useEffect(() => {
    if (!isEmpty(factories)) {
      factories.forEach((elements) => {
        elements.name = elements.factoryName;
      });
    }
  }, [factories]);

  useEffect(() => {
    const upnewArr = [];
    if (tier2AndAboveList?.length || tier1List?.length) {
      const rsArray = uniqBy([...tier1List, ...tier2AndAboveList], 'name');
      const uniqueRs = [];
      const uniqueRsArray = [];
      rsArray.forEach((val) => {
        if (uniqueRs.indexOf(val._id) === -1) {
          uniqueRs.push(val._id);
          uniqueRsArray.push(val);
        }
      });
      upnewArr.push(...uniqueRsArray);
      upnewArr.forEach((ele) => {
        ele.label = ele.name;
        ele.value = ele._id;
      });
      setSupplierOptions(upnewArr);
    }
  }, [tier2AndAboveList, tier1List]);

  const colourRefDatas = (ele) => {
    if (selectedColourWay && showData?.colourWayRefsData?.length > 1) {
      if (ele?.colourWayId?._id === selectedColourWay?._id) {
        setTopColourWayrefData({
          colourRef: ele?.colourRefsDataAsPerSuppliers[0]?.colourRef?.name,
          colourConfirmationRef: ele?.colourRefsDataAsPerSuppliers[0]?.colourRefNumber,
        });
      }
    } else {
      setTopColourWayrefData({
        colourRef: ele?.colourRefsDataAsPerSuppliers[0]?.colourRef?.name,
        colourConfirmationRef: ele?.colourRefsDataAsPerSuppliers[0]?.colourRefNumber,
      });
    }
  };

  useEffect(() => {
    if (
      !isEmpty(showData?.colourWayRefsData) &&
      (!isEmpty(selectedColourWay) || selectedColourWay !== null) &&
      (!isEmpty(selectedSupplier) || selectedSupplier !== null)
    ) {
      showData?.colourWayRefsData?.forEach((ele) => {
        const checkFoundSupplier = ele?.colourRefsDataAsPerSuppliers?.find((vl) => ele?.tier1Supplier === selectedSupplier?._id);
        if (checkFoundSupplier) {
          colourRefDatas(ele);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedColourWay, selectedSupplier, showData]);
  // discusson KJ

  useEffect(() => {
    if (selectedSupplier !== null || selectedColourWay !== null || selectedCompSupplier !== null) {
      const filterCalled = async () => {
        const params = {
          bomComponentLibId: showData?.libId ? showData?.libId : showData?._id,
          pageIndex: 1,
          pageSize: Page_Size,
        };
        if (selectedSupplier) {
          params.productSupplierId = selectedSupplier?._id;
        }
        if (selectedCompSupplier) {
          params.componentSupplierId = selectedCompSupplier?._id;
        }
        if (selectedColourWay) {
          params.colourwayId = selectedColourWay?._id;
        }
        if (selectedColourWayRef) {
          params.colourwayIdRef = selectedColourWayRef?._id;
        }
        if (selectedColourWayName) {
          params.colourwayIdName = selectedColourWayName?._id;
        }
        params.isBomLibrary = !!fromBomLib;
        setstate((prev) => ({ ...prev, hasMore: false }));
        dispatch(action.updateTotalCount());
        await dispatch(action.getAllUsageProducts(params));
      };
      filterCalled();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSupplier, selectedColourWay, selectedCompSupplier, fromBomLib, selectedColourWayRef, selectedColourWayName]);

  const handleStatus = (item) => {
    return (
      <td>
        <div className="document-title position-static">{qualityisNotAutoApproved(item)}</div>
      </td>
    );
  };

  const checkQualityStatus = useMemo(() => {
    let quality = 'No Quality Status';
    if (Array.isArray(showData?.bomApprovals) && showData?.bomApprovals?.length > 0) {
      const qualityRejctStatus = showData?.bomApprovals.filter((val) => val.status === 0);
      const approvedStatus = showData?.bomApprovals.filter((val) => val.status === 1);
      if (showData?.bomApprovals.length !== 0 && qualityRejctStatus?.length === showData?.bomApprovals?.length) {
        quality = 'Quality Rejected';
      } else if (showData?.bomApprovals?.length !== 0 && approvedStatus?.length === showData?.bomApprovals?.length) {
        quality = 'Quality Approved';
      }
    } else {
      quality = 'Pending';
    }
    return quality;
  }, [showData?.bomApprovals]);

  const qualityisNotAutoApproved = (item) => {
    if (!fromBomLib) {
      const rejectedCase = ['Quality Rejected'].includes(checkQualityStatus) ? 'rejected' : 'pending';
      const approvedCase = ['Quality Approved'].includes(checkQualityStatus) ? 'approved' : rejectedCase;
      const classNames = ['No Quality Status'].includes(checkQualityStatus) ? 'deleted' : approvedCase;

      return (
        <>
          <span>{checkQualityStatus}</span>
          <span className={`col-status right ${classNames}`} />
        </>
      );
    }
    return !isEmpty(item?.qualityAutoApprove) ? (
      <>
        <span>{t('FILTER.QUALITY_APPROVED')}</span>
        <span className="col-status right approved" />
      </>
    ) : (
      <>
        <span>{t('FILTER.NO_QUALITY_STATUS')}</span>
        <span className="col-status right deleted" />
      </>
    );
  };

  const forColourApproval = (item) => {
    return (
      <td className="btm-fix">
        <div className="document-title position-static">{colourisNotAutoApproved(item)}</div>
      </td>
    );
  };

  const colourWaysChanges = (objs) => {
    let cols = 'pending';
    if (selectedSupplier?._id === objs?.tier1Supplier?._id && objs?.colourWayId?._id === selectedColourWay?._id) {
      if (objs?.colourRefsDataAsPerSuppliers[0]?.autoApprove === true) {
        cols = 'Approved';
      } else if (objs?.colourRefsDataAsPerSuppliers[0]?.autoApprove === false) {
        cols = 'rejected';
      }
      return cols;
    }
  };

  const checkColourStatus = useMemo(() => {
    let colourStatus = 'pending';
    if (
      selectedSupplier &&
      selectedColourWay &&
      selectedCompSupplier &&
      selectedColourWayRef &&
      selectedColourWayName &&
      Array.isArray(showData?.colourWayRefsData) &&
      showData?.colourWayRefsData.length > 0
    ) {
      const targetColourWayId = selectedColourWay?._id;
      const targetColourRef = selectedColourWayRef?._id;
      const targetTier1Supplier = selectedSupplier?._id;
      const targetComponentSupplier = selectedCompSupplier?._id;
      const targetColourRefName = selectedColourWayName?._id;
      // Find the index of the colourWayRefsData array element with matching colourWayId
      const index = showData?.colourWayRefsData.findIndex((cw) => {
        return cw?.colourWayId?._id === targetColourWayId;
      });
      if (index !== -1) {
        // Find the colourRefsDataAsPerSuppliers element with matching criteria
        const matchingElement = showData?.colourWayRefsData[index]?.colourRefsDataAsPerSuppliers.find(
          (cr) =>
            cr?.colourRef?._id === targetColourRef &&
            cr?.tier1Supplier?._id === targetTier1Supplier &&
            cr?.componentSupplier?._id === targetComponentSupplier &&
            cr?.colourRefName?._id === targetColourRefName,
        );
        if (matchingElement) {
          if (matchingElement.status === 1) {
            colourStatus = 'Approved';
          } else if (matchingElement.status === 0) {
            colourStatus = 'rejected';
          }
        }
      }
    }
    return colourStatus;
  }, [showData?.colourWayRefsData, selectedSupplier, selectedColourWay, selectedCompSupplier, selectedColourWayRef, selectedColourWayName]);

  const colourisNotAutoApproved = (ele) => {
    let colours;
    const cols = [];
    if (fromBomLib) {
      if (Array.isArray(ele?.colourWayRefsData) && !isEmpty(selectedColourWay) && !isEmpty(ele?.colourWayRefsData)) {
        ele.colourWayRefsData.forEach((objs) => {
          cols.push(colourWaysChanges(objs));
        });
        colours = cols.includes('Approved') ? 'Approved' : ifRejected(cols);
      } else {
        return (
          <>
            <span>{t('FILTER.NO_COLOR_STATUS')}</span>
            <span className="col-status right deleted" />
          </>
        );
      }
    } else {
      colours = checkColourStatus;
    }
    switch (colours) {
      case 'Approved':
        return (
          <>
            <span>{t('FILTER.COLOR_APPROVED')}</span>
            <span className="col-status right approved" />
          </>
        );
      case 'rejected': {
        return fromBomLib ? (
          <>
            <span>{t('FILTER.NO_COLOR_STATUS')}</span>
            <span className="col-status right deleted" />
          </>
        ) : (
          <>
            <span>{t('FILTER.COLOR_REJECTED')}</span>
            <span className="col-status right rejected" />
          </>
        );
      }
      case 'pending':
        return (
          <>
            <span>{t('FILTER.NO_COLOR_STATUSS')}</span>
            <span className="col-status right deleted" />
          </>
        );
      default:
        return (
          <>
            <span>{t('FILTER.NO_COLOR_STATUSS')}</span>
            <span className="col-status right pending" />
          </>
        );
    }
  };

  const ifRejected = (cols) => {
    return cols.includes('rejected') ? 'rejected' : 'pending';
  };

  const handleCancle = () => {
    setSaveEdit(!savedEdit);
  };

  const showCreatedandModified = (item) => {
    return (
      <button type="button" className="btn p-0" style={{ margin: '0' }}>
        <div className="info-container testing-action-spaceremoval">
          <span className="icon-Information  f-20" />
          <div className="info-content">
            {item?.createdBy && (
              <p className="text-left m-0">
                <strong>{t('FILTER.CREATED')}</strong> : {item?.createdBy && `${item?.createdBy} | `}
                {moment(item?.createdAt).format('DD-MMMM-YYYY, h:mm a')}
              </p>
            )}
            {item?.modifiedBy && (
              <p className="text-left m-0">
                <strong>{t('PROGRESS_INDICATOR.MODIFI')}</strong> : {item?.modifiedBy && `${item?.modifiedBy} | `}
                {moment(item?.updatedAt).format('DD-MMMM-YYYY, h:mm a')}
              </p>
            )}
          </div>
        </div>
      </button>
    );
  };

  const handleEdit = () => {
    setSaveEdit(true);
    setSizeValue(showData?.size);
    console.log('🚀 ~ handleEdit ~ showData:', showData);
    setWeightValue(showData?.weight);
    setWeightUOM(showData?.weightUnitOfMeasure);
    setQuntityValue(showData?.quantity);
    setQuntityUOM(showData?.quantityUnitOfMeasure);
    setSizeUOM(showData?.sizeUnitOfMeasure);
    setAddInfoValue(showData?.additionalInfo);
    setComponentDescValue(showData?.bomDescription);
    setBomSubType(showData?.bomSubType);
    setPricePerUnitValue(showData?.pricePerUnit);
    setPricePerUnitCurrency(showData?.pricePerUnitCurrency ? { label: showData?.pricePerUnitCurrency, value: showData?.pricePerUnitCurrency } : null);
    if (!isEmpty(showData?.BOMSupplier) || showData.BOMSupplier !== null) {
      const filterdData = showData?.BOMSupplier?.map((item) => {
        item.label = item?.name;
        item.value = item?._id;
        return item;
      });
      selectBomSuppliers(uniqBy([...filterdData], 'name'));
    }
    const comp = [];
    if (!isEmpty(showData?.composition)) {
      showData?.composition?.forEach((element) => {
        console.log('🚀 ~ handleEdit ~ element:', element);

        // Handle both string and object formats for composition data
        if (typeof element === 'string') {
          // Handle string format like "50%Cotton"
          const CompositionNameArray = Composition?.filter((compArrEle) => compArrEle?.name?.trim() === element?.split('%')[1]?.trim());
          comp?.push({
            percentage: element?.split('%')[0],
            composition: CompositionNameArray[0],
          });
        } else if (typeof element === 'object' && element?.percentage && element?.composition) {
          // Handle object format with percentage and composition properties
          comp?.push({
            percentage: element?.percentage,
            composition: element?.composition,
          });
        }
      });
    }
    setCustomBom({
      composition: [...comp],
    });
  };

  const forCompoSave = () => {
    const finalArr = [];
    customBom?.composition?.forEach((obj) => {
      if (obj?.percentage !== null && obj?.composition !== null) {
        finalArr.push({
          percentage: obj?.percentage,
          composition: obj?.composition?._id,
        });
      }
    });
    return finalArr;
  };

  const forBomSuppliers = () => {
    const ids = [];
    BomSuppliers.forEach((ele) => {
      ids.push(ele?._id);
    });
    return ids;
  };

  function groupAndMerge(data) {
    const resultMap = new Map();
    data?.forEach((doc) => {
      const colourWayId = doc?.colourWayId?._id;
      const existingDoc = resultMap?.get(colourWayId);
      if (existingDoc?.colourRefsDataAsPerSuppliers && doc?.colourRefsDataAsPerSuppliers) {
        existingDoc.colourRefsDataAsPerSuppliers.push(...doc.colourRefsDataAsPerSuppliers);
      } else {
        resultMap?.set(colourWayId, { ...doc });
      }
    });

    return [...resultMap.values()];
  }

  const formatColourWayRefsData = (colourRefArry) => {
    const manipulatedArray = [];
    const colourewausRefData = groupAndMerge(colourRefArry);
    if (colourewausRefData && colourewausRefData.length > 0) {
      colourewausRefData.forEach((colur) => {
        if (colur?.colourWayId) {
          if (colur?.colourRefsDataAsPerSuppliers && colur?.colourRefsDataAsPerSuppliers.length > 0) {
            const newManipulateColourRefAsSupplier = [];
            colur?.colourRefsDataAsPerSuppliers?.forEach((colourSupp) => {
              const objs = {
                ...colourSupp,
                colourRef: typeof colourSupp?.colourRef === 'object' ? colourSupp?.colourRef?._id : colourSupp?.colourRef,
                tier1Supplier: typeof colourSupp?.tier1Supplier === 'object' ? colourSupp?.tier1Supplier?._id : colourSupp?.tier1Supplier,
                componentSupplier: typeof colourSupp?.componentSupplier === 'object' ? colourSupp?.componentSupplier?._id : colourSupp?.componentSupplier,
                colourRefName: typeof colourSupp?.colourRefName === 'object' ? colourSupp?.colourRefName?._id : colourSupp?.colourRefName,
                approveBy: typeof colourSupp?.approveBy === 'object' ? colourSupp?.approveBy?._id : colourSupp?.approveBy,
                autoApprove: colourSupp?.autoApprove || false,
              };
              if (objs?.componentSuppliersOPtionsMemo) delete objs?.componentSuppliersOPtionsMemo;
              newManipulateColourRefAsSupplier.push(objs);
            });
            colur.colourRefsDataAsPerSuppliers = newManipulateColourRefAsSupplier;
          }
          colur.colourWayId = typeof colur?.colourWayId === 'object' ? colur?.colourWayId?._id : colur?.colourWayId;
          delete colur?.supplierList;
          manipulatedArray.push(colur);
        }
      });
    }
    return manipulatedArray;
  };

  const handleSave = async () => {
    console.log('🚀 ~ handleSave ~ showData:', showData);
    const params = {
      BOMSupplier: forBomSuppliers(),
      additionalInfo: addInfoValue,
      bomDescription: componentDescValue,
      bomSubType: bomSubType?._id,
      bomType: showData?.bomType?._id,
      colorAutoApprove: showData?.colorAutoApprove,
      colourWayRefsData: showData?.colourWayRefsData ? formatColourWayRefsData(showData?.colourWayRefsData) : [],
      composition: forCompoSave(), // check this
      fullImage: 'DoNotChange',
      image: 'DoNotChange',
      placement: showData?.placement,
      qualityAutoApprove: showData?.qualityAutoApprove,
      quantity: quntityValue,
      quantityUnitOfMeasure: quntityUOM?._id,
      referenceCode: showData?.referenceCode,
      removeImage: false,
      size: sizeValue,
      sizeUnitOfMeasure: sizeUOM?._id,
      suppliers: forSupplier(), // check this
      weight: weightValue,
      weightUnitOfMeasure: weightUOM?._id,
      _id: showData._id,
      combinationSuppliers: showData?.combinationSuppliers || [],
      pricePerUnitCurrency: pricePerUnitCurrency?.value,
      pricePerUnit: pricePerUnitValue,
      finished: showData?.finished?._id,
      newPlacement: showData?.newPlacement?.map((ele) => ele?._id) || [],
      dynamicColumn:
        showData?.dynamicColumn?.map((ele) => ({
          colId: ele?._id || ele?.colId?._id,
          valueId: ele?.optionsValue?._id ? { _id: ele?.optionsValue?._id, keyName: ele?.optionsValue?.keyName } : ele?.valueId,
          valueText: ele?.valueText ? ele?.valueText : '',
        })) || [],
      subBomList: showData?.subBomList || [],
      subBOMSwitch: showData?.subBOMSwitch || false,
      productImpact: showData?.productImpact || null,
    };
    if (fromBomLib) {
      await dispatch(bomAction.EditBomLibaray(params, showData?._id, t));
      const gettparams = {
        bomTypeId: paramId?.id,
        pageIndex: 1,
        pageSize: 20,
      };
      await dispatch(bomAction.getBomLibraryGroup(gettparams, t));
    } else {
      const updateParams = { library: { ...params } };
      await dispatch(devBomAction.updateCards(showData?.bomType?._id, showData?.devOrderId, showData?._id, updateParams, t));
      const get_params = {
        pageIndex: 1,
        pageSize: 20,
      };
      await dispatch(devBomAction.fetchCards(showData?.bomType?._id, showData?.devOrderId, get_params));
    }
    const getparams = {
      bomComponentLibId: showData?.libId ? showData?.libId : showData?._id,
      isBomLibrary: !!fromBomLib,
      pageIndex: 1,
      pageSize: Page_Size,
    };
    setstate((prev) => ({ ...prev, hasMore: false }));

    dispatch(action.updateTotalCount());
    await dispatch(action.getAllUsageProducts(getparams));
    setSaveEdit(false);
  };

  const actionButtons = (item) => {
    return savedEdit ? (
      <div className="d-flex new-listing-action justify-content-end align-items-center">
        <CustomTooltip placement="top" tooltipText={t('SPEC_TEMP_LIBRARY.SAVE')}>
          <button
            className="btn p-0"
            onClick={handleSave}
            type="button"
            aria-label="save"
            disabled={
              (!isEmpty(customBom.composition.percentage) && isEmpty(customBom.composition.composition)) ||
              (!isEmpty(customBom.composition.composition) && isEmpty(customBom.composition.percentage))
            }
          >
            <i className="icon-Save-1 f-20" />
          </button>
        </CustomTooltip>
        <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.CANCEL')}>
          <button aria-label="close" type="button" className="btn p-0" onClick={() => handleCancle()}>
            <i className="icon-close f-16" />
          </button>
        </CustomTooltip>
      </div>
    ) : (
      <div className="d-flex new-listing-action justify-content-end align-items-center">
        <CustomTooltip placement="top" tooltipText={t('SPEC_TEMP_LIBRARY.EDIT')}>
          <button aria-label="Edit" type="button" className="btn p-0" onClick={handleEdit}>
            <i className="icon-Edit-1  f-20" />
          </button>
        </CustomTooltip>
        {showCreatedandModified(item)}
      </div>
    );
  };

  const forComposition = (item) => {
    const compos = [];
    if (Array.isArray(item?.composition)) {
      item?.composition?.forEach((ele) => {
        if (typeof ele === 'string') {
          const compositions = ele?.split('%');
          compos.push(`${compositions[0]} % ${compositions[1]}`);
        } else {
          compos.push(`${ele?.percentage} % ${ele?.composition?.name}`);
        }
      });
    }
    return compos.join(' , ');
  };

  const forComponentSuppliers = (item) => {
    const bomSupps = [];
    const combSupps = [];
    if (item?.BOMSupplier?.length > 0) {
      if (Array.isArray(item?.BOMSupplier)) {
        item?.BOMSupplier?.forEach((ele) => {
          bomSupps.push(ele?.name);
        });
      }
      return !isEmpty(bomSupps) && item?.BOMSupplier?.length === 1 ? bomSupps[0] : hoverMultipleTooltip(`${bomSupps?.length}`, bomSupps.join(' , '));
    }
    if (item?.combinationSuppliers?.length > 0) {
      if (Array.isArray(item?.combinationSuppliers)) {
        item?.combinationSuppliers?.forEach((ele) => {
          combSupps.push(ele?.componentSupplier?.name);
        });
      }
      return !isEmpty(combSupps) && item?.combinationSuppliers?.length && combSupps.join(', ');
    }
  };

  const handleChangeComposition = (event, index) => {
    const fieldName = event?.target?.name;
    const value = event?.target?.value;
    if (fieldName && value) {
      if (!isEmpty(customBom.composition)) {
        const rows = [...customBom.composition];
        rows[index] = {
          ...rows[index],
          percentage: value,
        };
        setCustomBom({
          ...customBom,
          composition: rows,
        });
      }
    } else if (!isEmpty(customBom.composition) && fieldName === undefined) {
      const rows = [...customBom.composition];
      rows[index] = {
        ...rows[index],
        composition: event,
      };
      setCustomBom({
        ...customBom,
        composition: rows,
      });
    } else {
      const rows = [...customBom.composition];
      rows[index] = {
        ...rows[index],
        percentage: null,
      };
      setCustomBom({
        ...customBom,
        composition: rows,
      });
    }
  };

  const handleAddRow = () => {
    setCustomBom({
      ...customBom,
      composition: [
        ...customBom.composition,
        {
          percentage: null,
          composition: null,
        },
      ],
    });
  };

  const handleRemoveClick = (index) => {
    if (customBom.composition.length === 1) {
      return false;
    }
    const list = [...customBom.composition];
    list.splice(index, 1);
    setCustomBom({
      composition: list,
    });
  };

  const forEditingComposition = () => {
    return Array.isArray(customBom?.composition) && !isEmpty(customBom?.composition) ? (
      customBom?.composition?.map((ele, i) => {
        return (
          <div key={ele?.percentage} className={i >= 0 ? 'mt-2 mb-2 d-flex' : 'd-flex'}>
            <FormGroup className="mb-0">
              <div className="common-input-control mb-0" style={{ width: '100px' }}>
                <input
                  name="percentage"
                  type="number"
                  className="form-control text-bordered"
                  value={ele?.percentage}
                  onChange={(e) => handleChangeComposition(e, i)}
                  placeholder={t('TAKING_DATES.PERCENTAGE')}
                  min="0"
                  max="100"
                  onInput={(e) => (e.target.value = Math.abs(e.target.value))}
                />
              </div>
            </FormGroup>
            <div className="common-react-select mb-0">
              <Select
                name="composition"
                maxMenuHeight={132}
                menuPlacement="top"
                menuPosition="fixed"
                key={0}
                options={Composition}
                getOptionLabel={(option) => `${option.name}`}
                getOptionValue={(option) => `${option._id}`}
                value={ele?.composition}
                styles={customStylesForProdAttribute}
                onChange={(e) => handleChangeComposition(e, i)}
                placeholder={t('TAKING_DATES.COMPOSITION')}
                isClearable
                className="common-select pl-2"
                classNamePrefix="common-select"
              />
            </div>
            {customBom?.composition?.length > 0 && customBom?.composition?.length === i + 1 && (
              <>
                <a href={() => false} onClick={() => handleAddRow()} className="ml-16 btn p-0 ">
                  <span className="icon-Add" />
                </a>
                {customBom?.composition?.length !== 1 && (
                  <a href={() => false} onClick={() => handleRemoveClick(i)} className="btn p-0 ml-16">
                    <span className="icon-Delete" />
                  </a>
                )}
              </>
            )}
          </div>
        );
      })
    ) : (
      <div className="d-flex justify-content-end">
        <a href={() => false} onClick={() => handleAddRow()} className="btn btn-outline">
          <span className="icon-add" />
        </a>
      </div>
    );
  };

  const handleChange = (e) => {
    switch (e.target.name) {
      case 'addInfo':
        setAddInfoValue(e.target.value);
        break;
      case 'bomDescription':
        setComponentDescValue(e.target.value);
        break;
      case 'size':
        setSizeValue(e.target.value);
        break;
      case 'weight':
        setWeightValue(e.target.value);
        break;
      case 'quantity':
        setQuntityValue(e.target.value);
        break;
      case 'pricePerUnit':
        setPricePerUnitValue(e.target.value);
        break;
      default:
        console.log('...>>>', e.target);
        break;
    }
  };

  const handleSelectWeight = (e) => {
    setWeightUOM(e);
  };

  const handleSelectQuantity = (e) => {
    setQuntityUOM(e);
  };

  const handleSelectsize = (e) => {
    setSizeUOM(e);
  };

  const handleSelectPricePerUnitCurrency = (e) => {
    setPricePerUnitCurrency(e);
  };

  const handleSelectColourWay = async (e) => {
    setSelectedColourWay(e);
    setTopColour(e);
    if (e === null) {
      setstate((prev) => ({ ...prev, hasMore: false }));

      dispatch(action.updateTotalCount());

      await dispatch(
        action.getAllUsageProducts({
          bomComponentLibId: showData?.libId ? showData?.libId : showData?._id,
          isBomLibrary: !!fromBomLib,
          pageIndex: 1,
          pageSize: Page_Size,
        }),
      );
    }
    setTopColourWayrefData({ colourRef: '', colourConfirmationRef: '' });
  };

  const handleSelectSupplier = async (e) => {
    setSelectedSupplier(e);
    setTopSupplier(e);
    if (e === null) {
      setstate((prev) => ({ ...prev, hasMore: false }));

      dispatch(action.updateTotalCount());

      await dispatch(
        action.getAllUsageProducts({
          bomComponentLibId: showData?.libId ? showData?.libId : showData?._id,
          isBomLibrary: !!fromBomLib,
          pageIndex: 1,
          pageSize: Page_Size,
        }),
      );
    }
    setTopColourWayrefData({ colourRef: '', colourConfirmationRef: '' });
  };

  const handleSelectCompSupplier = async (e) => {
    setSelectedCompSupplier(e);
    setTopCompSupplier(e);
    setTopColourWayrefData({ colourRef: '', colourConfirmationRef: '' });
    if (e === null) {
      setstate((prev) => ({ ...prev, hasMore: false }));

      dispatch(action.updateTotalCount());

      await dispatch(
        action.getAllUsageProducts({
          bomComponentLibId: showData?.libId ? showData?.libId : showData?._id,
          isBomLibrary: !!fromBomLib,
          pageIndex: 1,
          pageSize: Page_Size,
        }),
      );
    }
  };

  const handleBomSubType = (e) => {
    setBomSubType(e);
  };

  const handleSubtype = () => {
    return (
      <td>
        {savedEdit ? (
          <div className="common-react-select mb-0">
            <Select
              name="bomSubType"
              maxMenuHeight={132}
              menuPlacement="top"
              menuPosition="fixed"
              key={0}
              options={activeReferenceType}
              getOptionLabel={(option) => `${option.name}`}
              getOptionValue={(option) => `${option._id}`}
              value={bomSubType}
              styles={customStyles}
              onChange={(e) => handleBomSubType(e)}
              placeholder={t('FILTER.TEST_TYPES')}
              isClearable
              className="common-select"
              classNamePrefix="common-select"
            />
          </div>
        ) : (
          showData?.bomSubType?.name
        )}
      </td>
    );
  };

  const selectMulitpleBomSupplier = async (arry) => {
    if (arry) {
      selectBomSuppliers([arry]); // no need to do multiple selection as in modal popup we are having single selection only
    }
  };

  const handleComponentSupplier = () => {
    return (
      <td>
        {savedEdit && showData?.combinationSuppliers?.length === 0 ? (
          <div className="common-react-select mb-0">
            <Select
              name="BOMSupplier"
              options={SupplierOptions}
              value={BomSuppliers}
              onChange={(comp) => selectMulitpleBomSupplier(comp)}
              placeholder={t('TAKING_DATES.COMPONENT_SUPPLIER')}
              labelledBy={t('TAKING_DATES.COMPONENT_SUPPLIER')}
              styles={customStyles}
              isDisabled={checkArray(showData?.combinationSuppliers)}
              isClearable
              className="common-select"
              classNamePrefix="common-select"
            />
          </div>
        ) : (
          <>{forComponentSuppliers(showData)}</>
        )}
      </td>
    );
  };

  const unitsForSize = () => {
    return showData?.sizeUnitOfMeasure?.name ? showData?.sizeUnitOfMeasure?.name : '';
  };

  const unitsForWeight = () => {
    return showData?.weightUnitOfMeasure?.name ? showData?.weightUnitOfMeasure?.name : '';
  };

  const unitsForQuantity = () => {
    return showData?.quantityUnitOfMeasure?.name ? showData?.quantityUnitOfMeasure?.name : '';
  };

  // product supplier options list memo
  const productSupplierOptionsMemo = useMemo(() => {
    let tierSupplierList = [];
    if (showData?.libId === undefined) {
      if (Array.isArray(tier1List) && tier1List.length > 0) {
        tierSupplierList = tier1List;
      }
    } else if (Array.isArray(productSupplier) && productSupplier.length > 0) {
      tierSupplierList = uniqBy([...productSupplier], '_id');
    }
    return tierSupplierList;
  }, [tier1List, productSupplier, showData?.libId]);
  const currentURL = window.location.href;

  // main colourways list optiosn memo
  const colourWaysListMemo = useMemo(() => {
    let colourWaysList = [];
    if (Array.isArray(ProductColourList) && ProductColourList.length > 0) {
      const filteredColourWaysIsNotdeleted = ProductColourList?.filter((element) => !element.isDeleted);
      const filteredproductColourLibraries = [];
      if (currentURL.includes('development-order')) {
        for (const clState of filteredColourWaysIsNotdeleted) {
          for (const ele of productDetails?.colourLibraries || []) {
            if (clState?._id === ele) {
              filteredproductColourLibraries.push(clState);
            }
          }
        }

        colourWaysList = uniqBy([...filteredproductColourLibraries], 'name');
      } else {
        colourWaysList = filteredColourWaysIsNotdeleted;
      }
    }
    return colourWaysList;
  }, [ProductColourList, productDetails?.colourLibraries]);

  const formatParentColourwayOptionLabel = (option, { context }) => (context !== 'value' ? `${option.name} | ${option.newReferences}` : option.name);

  const formatChildRefColourwayOptionLabel = (option, { context }) => (context !== 'value' ? `${option.name} | ${option.newReferences}` : option.newReferences);

  useEffect(() => {
    async function fetchData() {
      let componentSuppliers = [];
      if (checkArray(showData?.BOMSupplier)) {
        componentSuppliers = showData?.BOMSupplier;
      } else if (checkArray(showData?.combinationSuppliers)) {
        const combinationArray = showData?.combinationSuppliers?.filter((vl) => vl?.componentSupplier).map((vl) => vl?.componentSupplier);
        componentSuppliers = combinationArray;
      }
      setState((prev) => ({
        ...prev,
        componentSupplierOptiosn: componentSuppliers,
      }));
    }
    fetchData();
  }, [showData?.BOMSupplier, showData?.combinationSuppliers, selectedSupplier, dispatch]);

  return (
    <div className=" table-responsive" id="TopProductAttribute">
      <table className="table product-bom-top-table custom-table m-0 layout-fixed" id="TopProductAttribute">
        <thead>
          <tr>
            <th className="text-left w-250px">
              <span className="cursor-pointer">{t('FILTER.COMPONET_REF')}</span>
            </th>
            <th className="text-left w-200px">
              <span className="cursor-pointer">{t('TAKING_DATES.BOM_TYPE')}</span>
            </th>
            <th className="text-left w-200px">
              <span className="cursor-pointer">{t('TAKING_DATES.COMPONENT_TYPE')}</span>
            </th>
            <th className="text-left w-200px">
              <span className="cursor-pointer">{t('TAKING_DATES.COMPONET_DESCRIPTION')}</span>
            </th>
            <th className="text-left w-200px">
              <span className="cursor-pointer">{t('TAKING_DATES.COMPONENET_SUPPLER_LABEL')}</span>
            </th>
            <th className="text-left w-280px">
              <span className="cursor-pointer">{t('TAKING_DATES.SIZE')}</span>
            </th>
            <th className="text-left w-280px">
              <span className="cursor-pointer">{t('TAKING_DATES.WEIGHT')}</span>
            </th>
            <th className="text-left w-280px">
              <span className="cursor-pointer">{t('TAKING_DATES.QUANTITY')}</span>
            </th>
            <th className="text-left w-280px">
              <span className="cursor-pointer">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.PRICE_PER_UNIT')}</span>
            </th>
            <th className="text-left w-350px">
              <span className="cursor-pointer">{t('TAKING_DATES.COMPOSITION')}</span>
            </th>
            <th className="text-left w-230px">
              <span className="cursor-pointer">{t('FILTER.ADDITIONAL_INFORMATION')}</span>
            </th>
            <th className="text-left w-150px">
              <span className="cursor-pointer">{t('TAKING_DATES.STATES')}</span>
            </th>
            <th className="w-120px text-right" />
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{shortenandHoverString(showData?.referenceCode, 50)}</td>
            <td>{showData?.bomType?.name}</td>
            {handleSubtype()}
            <td>
              {savedEdit ? (
                <FormGroup className="mb-0">
                  <div className="common-input-control mb-0">
                    <input
                      name="bomDescription"
                      key={0}
                      className="form-control text-bordered"
                      value={componentDescValue}
                      onChange={(e) => handleChange(e)}
                      type="text"
                      maxLength="200"
                    />
                  </div>
                </FormGroup>
              ) : (
                <span>{shortenandHoverString(showData?.bomDescription, 50)}</span>
              )}
            </td>

            {handleComponentSupplier()}
            <td>
              {savedEdit ? (
                <div className="d-flex">
                  <FormGroup className="mb-0">
                    <div className="common-input-control mb-0" style={{ width: '100px' }}>
                      <input name="size" key={0} className="form-control text-bordered" value={sizeValue} onChange={(e) => handleChange(e)} type="text" />
                    </div>
                  </FormGroup>
                  <div className="common-react-select mb-0">
                    <Select
                      name="sizeUOM"
                      maxMenuHeight={132}
                      className="pl-2 common-select"
                      menuPlacement="top"
                      menuPosition="fixed"
                      key={0}
                      options={unitOptions}
                      getOptionLabel={(option) => `${option.name}`}
                      getOptionValue={(option) => `${option._id}`}
                      value={sizeUOM}
                      styles={customStylesForProdAttribute}
                      onChange={(e) => handleSelectsize(e)}
                      placeholder={t('FILTER.SIZE_UOM')}
                      isClearable
                      classNamePrefix="common-select"
                    />
                  </div>
                </div>
              ) : (
                <span>{!isEmpty(showData?.size) && `${showData?.size} ${unitsForSize()}`}</span>
              )}
            </td>
            <td>
              {savedEdit ? (
                <div className="d-flex">
                  <FormGroup className="mb-0">
                    <div className="common-input-control mb-0" style={{ width: '100px' }}>
                      <input name="weight" key={0} className="form-control text-bordered" value={weightValue} onChange={(e) => handleChange(e)} type="text" />
                    </div>
                  </FormGroup>
                  <div className="common-react-select mb-0">
                    <Select
                      name="weightUOM"
                      className="pl-2 common-select"
                      maxMenuHeight={132}
                      menuPlacement="top"
                      menuPosition="fixed"
                      key={0}
                      options={unitOptions}
                      getOptionLabel={(option) => `${option.name}`}
                      getOptionValue={(option) => `${option._id}`}
                      value={weightUOM}
                      styles={customStylesForProdAttribute}
                      onChange={(e) => handleSelectWeight(e)}
                      placeholder={t('FILTER.WEIGHT_UOM')}
                      isClearable
                      classNamePrefix="common-select"
                    />
                  </div>
                </div>
              ) : (
                <span>{!isEmpty(showData?.weight) && `${showData?.weight} ${unitsForWeight()}`}</span>
              )}
            </td>
            <td>
              {savedEdit ? (
                <div className="d-flex">
                  <FormGroup className="mb-0">
                    <div className="common-input-control mb-0" style={{ width: '100px' }}>
                      <input
                        name="quantity"
                        key={0}
                        className="form-control text-bordered"
                        value={quntityValue}
                        onChange={(e) => handleChange(e)}
                        type="text"
                      />
                    </div>
                  </FormGroup>
                  <div className="common-react-select mb-0">
                    <Select
                      name="quntityUOM"
                      className="pl-2 common-select"
                      maxMenuHeight={132}
                      menuPlacement="top"
                      menuPosition="fixed"
                      key={0}
                      options={unitOptions}
                      getOptionLabel={(option) => `${option.name}`}
                      getOptionValue={(option) => `${option._id}`}
                      value={quntityUOM}
                      styles={customStylesForProdAttribute}
                      onChange={(e) => handleSelectQuantity(e)}
                      placeholder={t('PIM.DETAIL_PAGE.FILTER.QUANTITY_UOM')}
                      isClearable
                      classNamePrefix="common-select"
                    />
                  </div>
                </div>
              ) : (
                <span>{!isEmpty(showData?.quantity) && `${showData?.quantity} ${unitsForQuantity()}`}</span>
              )}
            </td>

            <td>
              {savedEdit ? (
                <div className="d-flex">
                  <FormGroup className="mb-0">
                    <div className="common-input-control mb-0" style={{ width: '100px' }}>
                      <input
                        name="pricePerUnit"
                        key={0}
                        className="form-control text-bordered"
                        value={pricePerUnitValue}
                        onChange={(e) => handleChange(e)}
                        type="text"
                        onKeyPress={(e) => {
                          const charCode = e.which ? e.which : e.keyCode;
                          if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </FormGroup>
                  <div className="common-react-select mb-0">
                    <Select
                      name="pricePerUnitCurrency"
                      className="pl-2 common-select"
                      maxMenuHeight={132}
                      menuPlacement="top"
                      menuPosition="fixed"
                      key={0}
                      options={currencyOptions}
                      getOptionLabel={(option) => `${option.label}`}
                      getOptionValue={(option) => `${option.value}`}
                      value={pricePerUnitCurrency}
                      styles={customStylesForProdAttribute}
                      onChange={(e) => handleSelectPricePerUnitCurrency(e)}
                      placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.CURRENCY')}
                      isClearable
                      classNamePrefix="common-select"
                    />
                  </div>
                </div>
              ) : (
                <span>{!isEmpty(showData?.pricePerUnit) && `${showData?.pricePerUnit} ${showData?.pricePerUnitCurrency || ''}`}</span>
              )}
            </td>

            <td>{savedEdit ? forEditingComposition() : <span>{forComposition(showData)}</span>}</td>
            <td>
              {savedEdit ? (
                <FormGroup className="mb-0">
                  <div className="common-input-control mb-0">
                    <input
                      name="addInfo"
                      key={0}
                      className="form-control text-bordered"
                      value={addInfoValue}
                      onChange={(e) => handleChange(e)}
                      type="text"
                      maxLength="200"
                    />
                  </div>
                  <div className="character-counter ng-binding">{addInfoValue?.length}/200</div>
                </FormGroup>
              ) : (
                <span>{shortenandHoverString(showData?.additionalInfo, 50)}</span>
              )}
            </td>
            {handleStatus(showData)}
            <td className="text-right">{actionButtons(showData)}</td>
          </tr>
          <tr>
            <td colSpan={11}>
              <div className="d-flex">
                <div className="common-react-select mb-0 flex-fill">
                  <Select
                    name="SelectProductSupplier"
                    maxMenuHeight={132}
                    menuPosition="fixed"
                    menuPlacement="top"
                    options={productSupplierOptionsMemo}
                    isClearable
                    getOptionLabel={(option) => `${option.name}`}
                    getOptionValue={(option) => `${option._id}`}
                    value={selectedSupplier}
                    styles={SelectBoxStylesForProductAttribute}
                    onChange={(e) => handleSelectSupplier(e)}
                    placeholder={t('TAKING_DATES.PRODUCT_SUPLIER')}
                    className="common-select"
                    classNamePrefix="common-select"
                  />
                </div>
                <div className="common-react-select mb-0 flex-fill ml-2">
                  <Select
                    name="SelectComponentSupplier"
                    maxMenuHeight={132}
                    menuPosition="fixed"
                    menuPlacement="top"
                    options={componentSupplierOptiosn}
                    isClearable
                    getOptionLabel={(option) => `${option.name}`}
                    getOptionValue={(option) => `${option._id}`}
                    value={selectedCompSupplier}
                    styles={SelectBoxStylesForProductAttribute}
                    onChange={(e) => handleSelectCompSupplier(e)}
                    placeholder={t('FILTER.COMPONENT_SUPLIERES')}
                    className="common-select"
                    classNamePrefix="common-select"
                  />
                </div>
                <div className="common-react-select  mb-0flex-fill ml-2">
                  <Select
                    name="SelectColourWays"
                    maxMenuHeight={132}
                    menuPosition="fixed"
                    menuPlacement="top"
                    formatOptionLabel={formatParentColourwayOptionLabel}
                    options={colourWaysListMemo}
                    getOptionLabel={(option) => (option?.references ? `${option.name} | ${option.references}` : `${option.name}`)}
                    isClearable
                    getOptionValue={(option) => `${option._id}`}
                    value={selectedColourWay}
                    styles={SelectBoxStylesForProductAttribute}
                    onChange={(e) => handleSelectColourWay(e)}
                    className="common-select"
                    classNamePrefix="common-select"
                    placeholder={t('COSTING_TO_DO_LIST.COLORWAY')}
                  />
                </div>
                <div className="common-react-select mb-0 flex-fill ml-2">
                  <Select
                    name="SelectColourWays"
                    maxMenuHeight={132}
                    menuPosition="fixed"
                    menuPlacement="top"
                    formatOptionLabel={formatParentColourwayOptionLabel}
                    options={ProductColourList}
                    getOptionLabel={(option) => (option?.references ? `${option.name} | ${option.references}` : `${option.name}`)}
                    isClearable
                    getOptionValue={(option) => `${option._id}`}
                    value={selectedColourWayName}
                    styles={SelectBoxStylesForProductAttribute}
                    onChange={(e) => setSelectedColourWayName(e)}
                    placeholder={t('FILTER.COLOURWAY_NAME')}
                    className="common-select"
                    classNamePrefix="common-select"
                  />
                </div>
                <div className="common-react-select mb-0 flex-fill ml-2">
                  <Select
                    name="SelectColourWays"
                    maxMenuHeight={132}
                    menuPosition="fixed"
                    menuPlacement="top"
                    formatOptionLabel={formatChildRefColourwayOptionLabel}
                    options={ProductColourList}
                    getOptionLabel={(option) => (option?.references ? `${option.name} | ${option.references}` : `${option.name}`)}
                    isClearable
                    getOptionValue={(option) => `${option._id}`}
                    value={selectedColourWayRef}
                    styles={SelectBoxStylesForProductAttribute}
                    onChange={(e) => setSelectedColourWayRef(e)}
                    placeholder={t('FILTER.COLOURWAY_REFERENCE')}
                    className="common-select"
                    classNamePrefix="common-select"
                  />
                </div>
              </div>
            </td>
            {forColourApproval(showData)}
            <td />
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default TopProductAttributeTable;
